/*jslint browser: true*/
/*global jQuery*/
/*jslint vars: true*/

(function ($) {
    $.fn.bootstrapDynamicTabs = function () {

		this.each(function () {
			var $horizontalContainer = $(this);

			function DynamicTabs() {

				// create wrapper and menu if first time
				if ($horizontalContainer.parent('.dynamic-tabs-container').length === 0) {

					// add wrapper
					$horizontalContainer.addClass("dynamic-tabs").wrap("<div class='dynamic-tabs-container clearfix'></div>");

					// Attach a dropdown to the right of the tabs bar
					// This will be toggled if tabs can't fit in a given viewport size
					$horizontalContainer.after(
						//nav navbar-nav navbar-right dropdown dropleft 
						"<div class='dropdown dropleft tabs-dropdown'>"+
							"<button class='btn btn-link dropdown-toggle' data-toggle='dropdown'>"+
								"<span class='fa fa-ellipsis-v' style='font-size: 1.6em;'/>"+
							"</button>"+
							"<ul class='dropdown-menu new-dropdown p-0' role='menu'></ul>"+
						"</div>"
						// "<div class='btn-group dropleft tabs-dropdown'>"+
						// 	"<button type='button' class='btn btn-secondary dropdown-toggle' data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'>"+
						// 		"..."+
						// 	"</button>"+
						// 	"<div class='dropdown-menu'>"+
						// 	""	+
						// 	"</div>"+
						// "</div>"
					);
				}

				// Mark each tab with a 'tab-id' for easy access
				var $tabs = $horizontalContainer.children('li');
				$tabs.each(function (i) {
					$(this)
						.addClass("dynamic-tab")
						.attr("tab-id", i);
				});

				// Update tabs funtion
				var updateTabs = function () {
					var i, horizontalTab, tabId, verticalTab, tabWidth, isVisible;

					var availableWidth = $horizontalContainer.width();
					var numVisibleHorizontalTabs = 1;

					var activeTab = $horizontalContainer.find('.active');
					var activeTabIndex = activeTab.parent("li").index();

					// active tab is always visible
					activeTab.parent("li").toggleClass('d-none', false);
					availableWidth = availableWidth - activeTab.outerWidth(true);

					// Determine which tabs to show/hide
					var $tabs = $horizontalContainer.children('li');

					// from active to firt
					for (i = activeTabIndex - 1; i >= 0; i--) {
						horizontalTab = $tabs.eq(i);
						if (availableWidth > 0) {
							horizontalTab.toggleClass('d-none', false);
							tabWidth = horizontalTab.outerWidth(true);
							isVisible = tabWidth <= availableWidth;
							if (isVisible) {
								availableWidth = availableWidth - tabWidth;
								numVisibleHorizontalTabs++;
							} else {
								availableWidth = -1;
							}
						} else {
							isVisible = false;
						}
						horizontalTab.toggleClass('d-none', !isVisible);
					}

					// from active to last
					for (i = activeTabIndex + 1; i < $tabs.length; i++) {
						horizontalTab = $tabs.eq(i);
						if (availableWidth > 0) {
							horizontalTab.toggleClass('d-none', false);
							tabWidth = horizontalTab.outerWidth(true);
							isVisible = tabWidth <= availableWidth;
							if (isVisible) {
								availableWidth = availableWidth - tabWidth;
								numVisibleHorizontalTabs++;
							} else {
								availableWidth = -1;
							}
						} else {
							isVisible = false;
						}
						horizontalTab.toggleClass('d-none', !isVisible);
					}

					// Toggle the Tabs dropdown if there are more tabs than can fit in the tabs horizontal container
					var numVisibleVerticalTabs = $tabs.length - numVisibleHorizontalTabs;
					var hasVerticalTabs = (numVisibleVerticalTabs > 0);
					$horizontalContainer.siblings(".tabs-dropdown").toggleClass("d-none", !hasVerticalTabs);
				};

				// tabs dropdown event
				var onDropDow = function () {
					// Clone each tab into the dropdown
					var $verticalContainer = $horizontalContainer.siblings(".tabs-dropdown").find(".dropdown-menu");

					$verticalContainer.html("");
					$verticalContainer.css("z-index", 1050);
					
					$horizontalContainer.children('li').each( function (index, element) {
						if ($(element).hasClass("d-none")) {
							var htab = document.createElement("li");

							$(htab).append('<a href="#">'+$(element).children('a').html()+'</a>');
							$(htab).toggleClass('active',$(element).hasClass('active'));
							$(htab).toggleClass('aria-selected',true);
							$(htab).attr("tab-id", index);
							$(htab).on("click", function (e) {
								console.log("e.target")
								console.log(e.target)
								e.preventDefault()
								var thisTabId = $(this).attr("tab-id")
								console.log("thisTabId")
								console.log(thisTabId)
								$horizontalContainer.find("[tab-id=" + thisTabId + "] a").tab("show");
								updateTabs();
							});
							$verticalContainer.append(htab);
						}
					});
				};
				$horizontalContainer.siblings(".tabs-dropdown").off('show.bs.dropdown').on('show.bs.dropdown', onDropDow);

				// update tabs
				updateTabs();

				// Update tabs on window resize
				$(window).off("resize.dyntabs").on("resize.dyntabs", function () {
					updateTabs();
				});

				$(window).on('shown.bs.modal', function(){
					updateTabs();
				})
			}

			return new DynamicTabs();
		});
	};
}(jQuery));
